import $ from "jquery";
import * as bootstrap from 'bootstrap';
window.$ = $;
window.jQuery = $;
jQuery = $;
jQuery.noConflict();

import Stepper from 'bs-stepper';
import 'bs-stepper/dist/css/bs-stepper.min.css';
import Swal from 'sweetalert2';
import 'sweetalert2/src/sweetalert2.scss';

$( "#preloader" ).show()


var ibanLengths = {
    'AL':28,'AD':24,'AT':20,'AZ':28,'BH':22,'BY':28,'BE':16,'BA':20,
    'BR':29,'BG':22,'CR':22,'HR':21,'CY':28,'CZ':24,'DK':18,'DO':28,
    'TL':23,'EG':29,'SV':28,'EE':20,'FO':18,'FI':18,'FR':27,'GE':22,
    'DE':22,'GI':23,'GR':27,'GL':18,'GT':28,'HU':28,'IS':26,'IQ':23,
    'IE':22,'IL':23,'IT':27,'JO':30,'KZ':20,'XK':20,'KW':30,'LV':21,
    'LB':28,'LY':25,'LI':21,'LT':20,'LU':20,'MT':31,'MR':27,'MU':30,
    'MC':27,'MD':24,'ME':22,'NL':18,'MK':19,'NO':15,'PK':24,'PS':29,
    'PL':28,'PT':25,'QA':29,'RO':24,'LC':32,'SM':27,'ST':25,'SA':24,
    'RS':22,'SC':31,'SK':24,'SI':19,'ES':24,'SD':18,'SE':24,'CH':21,
    'TN':24,'TR':26,'UA':29,'AE':23,'GB':22,'VA':22,'VG':24
};

function updateIbanLengthHint(val) {
    var $hint = $('#iban-length-hint');
    if (!$hint.length) return;
    var cc = val.substring(0, 2).toUpperCase();
    var expectedLen = ibanLengths[cc];
    if (expectedLen && val.length < expectedLen) {
        var remaining = expectedLen - val.length;
        var template = $hint.data('template') || 'Noch :count Stellen';
        $hint.text(template.replace(':count', remaining)).removeClass('d-none').addClass('d-block');
    } else {
        $hint.text('').removeClass('d-block').addClass('d-none');
    }
}

function checkiban(iban) {

    iban = iban.replace(/\s/g, '').toUpperCase();
    $('#ibanfailed').removeClass("show");
    $('#in-iban-dismiss-validation').val(0);
    $('#in-iban-validation-state').val(0);
    $.ajax({
        url: 'https://openiban.com/validate/'+iban,	// replace with
        dataType: 'json',

        // dynamic value
        data: { // pass additional options
            "validateBankCode": true, 	// (not guaranteed)
            "getBIC": true 			// (not guaranteed)
        },
        success: function(data) {
            var result = data;
            $('#in-iban-validation-state').val(1);
            if(result.valid) {
                $('#tool-in-iban').html('<b>IBAN ist gültig!</b>');
                //$('#tool-in-iban').addClass('invalid-tooltip');
                $('#tool-in-iban').css('background-color', 'green');
                $('#iban_igno').prop('disabled', true);
                if (typeof data.bankData.bic != "undefined" && $("#in-bic").val().length == 0) {
                    $("#in-bic").val(data.bankData.bic);
                }
                disableIBANValidation();
            } else {
                $('#ibanfailed').addClass("show");
                $('#ibanfailed').show();
            }
            Swal.close();
        },
        error: function(xhr) {
            $('#ibanfailed').addClass("show");
            $('#ibanfailed').show();
        }
    });
}


function validatePayment() {
    if ($('#in-zahlart').val()==null) {
        $('#in-zahlart').addClass('is-invalid');
        $('#tool-in-zahlart').show();
        return 1;
    }
    return 0;
}

function parseMoney(v) {
    if (v === null || v === undefined) return 0;
    var s = String(v).replace(/[€\s]/g, '').replace(',', '.');
    if (s === '') return 0;
    var n = parseFloat(s);
    return isNaN(n) ? 0 : n;
}

function changeClaimExceedsPaid() {
    var schein = parseMoney($('#in-schein').val());
    var coin   = parseMoney($('#in-coin').val());
    var change = parseMoney($('#in-changecoin').val());
    var price  = parseMoney($('#in-preisselect').val());
    if (price <= 0) return false;
    if ((schein + coin) <= 0) return false;
    return (schein + coin - change) < price - 0.001;
}

function validateBrandFields(a) {
    var brands = (window.acData && Array.isArray(window.acData.brands)) ? window.acData.brands : null;
    if (!brands) return false;
    // The catalogue mixes spellings ("MARLBORO GOLD" from the machine dump,
    // "Marlboro Gold" from the seeder) and the server's exists rule matches
    // case-insensitively, so comparing verbatim here would reject entries the
    // backend accepts.
    var known = brands.map(function (brand) { return String(brand).toLowerCase(); });
    var flagged = false;
    [['#in-sorteselect', '#tool-in-sorteselect-unknown'],
     ['#in-sorteget',    '#tool-in-sorteget-unknown']].forEach(function(pair) {
        var $input = $(pair[0]);
        if (!$input.is(':visible')) return;
        var val = $input.val();
        if (val !== '' && known.indexOf(String(val).toLowerCase()) === -1) {
            $input.addClass('is-invalid');
            $(pair[1]).show();
            flagged = true;
        }
    });
    if (flagged) a.preventDefault();
    return flagged;
}

// The max attribute on the date input only limits what the picker offers — a
// typed value passes through untouched. Compare against that same boundary so
// the client refuses exactly what the server would reject.
function faultDateInFuture() {
    var $input = $('#in-date');
    var value = $input.val();
    var latest = $input.attr('max');
    // Both are ISO dates (YYYY-MM-DD), so a plain string compare is ordered.
    return value !== '' && !!latest && value > latest;
}

// A date before the window only raises the hint; the step stays passable. The
// boundary is rendered by the server, so it matches the day the server treats
// as today.
function faultDateTooOld() {
    var $input = $('#in-date');
    var value = $input.val();
    var oldest = $input.attr('data-oldest-online');
    // Both are ISO dates (YYYY-MM-DD), so a plain string compare is ordered.
    return value !== '' && !!oldest && value < oldest;
}

function updateFaultDateAgeHint() {
    if (faultDateTooOld()) {
        $('#fault-date-too-old').show();
    } else {
        $('#fault-date-too-old').hide();
    }
}

// Only the current day carries a time boundary — on an earlier date every
// time of day already lies in the past. The reference is the browser clock,
// which is also what the "Jetzt" button fills in, so the two cannot disagree.
// The server re-checks against Europe/Berlin and stays authoritative.
function faultTimeInFuture() {
    var $date = $('#in-date');
    var time = $('#in-time').val();
    if (time === '' || $date.val() === '' || $date.val() !== $date.attr('max')) return false;

    var now = new Date();
    var pad = function (n) { return n < 10 ? '0' + n : '' + n; };
    // Zero-padded HH:mm on both sides, so a string compare is ordered.
    return time > pad(now.getHours()) + ':' + pad(now.getMinutes());
}

function validateWhenBlock(a) {
    if (!$('#tog-when').is(':visible')) return false;
    // A fault outside the reporting window is not taken online. The report ends
    // on the cancel page, the same way it ends when the booking details from
    // the EC receipt are missing. The hint under the field has said so since
    // the date was entered; the navigation happens here so that typing a date
    // digit by digit cannot leave the form mid-entry.
    if (faultDateTooOld()) {
        a.preventDefault();
        window.location.href = '/cancel/date-too-old';
        return true;
    }
    var dateMissing = $('#in-date').val()=='';
    var timeMissing = $('#in-time').val()=='';
    var dateInFuture = !dateMissing && faultDateInFuture();
    var timeInFuture = !timeMissing && !dateInFuture && faultTimeInFuture();
    if (!dateMissing && !timeMissing && !dateInFuture && !timeInFuture) {
        $('#tog-when').removeClass('border border-2 border-danger');
        return false;
    }
    $('#tog-when').addClass('border border-2 border-danger');
    if (dateMissing) {
        $('#in-date').addClass('is-invalid');
        $('#tool-in-date').show();
    }
    if (dateInFuture) {
        $('#in-date').addClass('is-invalid');
        $('#tool-in-date-future').show();
    }
    if (timeMissing) {
        $('#in-time').addClass('is-invalid');
        $('#tool-in-time').show();
    }
    if (timeInFuture) {
        $('#in-time').addClass('is-invalid');
        $('#tool-in-time-future').show();
    }
    a.preventDefault();
    return true;
}

function checker(indi, a) {
    var nw = 0;
    if (indi=='2') {
        var ecConfirmed = $('#ec-verwendungszweck-confirmed').val();
        if ($('#in-zahlart').val()=='1' && ecConfirmed != '1') {
            $('#in-zahlart').addClass('is-invalid');
            $('#tool-in-zahlart').show();
            $('#ec-bank-warning').show().addClass('border border-2 border-danger');
            a.preventDefault();
            return;
        }
        if ($('#in-grund').val()=='0') {
            $('#in-grund').addClass('is-invalid');
            $('#tool-in-grund').show();
            a.preventDefault();
        }
        if ($('#in-grund').val()=='1') {
            if ($('#in-stoerart').val()=='0') {
                $('#in-stoerart').addClass('is-invalid');
                $('#tool-in-stoerart').show();
                a.preventDefault();
            }
        }
        if ($('#in-grund').val()=='2') {
            if ($('#in-sorteselect').val()=='') {
                $('#in-sorteselect').addClass('is-invalid');
                $('#tool-in-sorteselect').show();
                nw = 1;
            }

            if ($('#in-preisselect').val()=='') {
                $('#in-preisselect').addClass('is-invalid');
                $('#tool-in-preisselect').show();
                nw = 1;
            }

            if (validatePayment()) {
                nw = 1;
            }

            if ($('#in-zahlart').val()=='2' || $('#in-zahlart').val()=='4') {
                if ($('#in-schein').val()=='0') {
                    $('#in-schein').addClass('is-invalid');
                    $('#tool-in-schein').show();
                    nw = 1;
                }
            }
            if ($('#in-zahlart').val()=='3' || $('#in-zahlart').val()=='4') {
                if ($('#in-coin').val()=='') {
                    $('#in-coin').addClass('is-invalid');
                    $('#tool-in-coin').show();
                    nw = 1;
                }
            }

            if (nw==1) {a.preventDefault()}
        }

        if ($('#in-grund').val()=='3') {

            nw = 0;

            if ($('#in-sorteselect').val()=='') {
                $('#in-sorteselect').addClass('is-invalid');
                $('#tool-in-sorteselect').show();
                nw = 1;
            }
            if ($('#in-preisselect').val()=='') {
                $('#in-preisselect').addClass('is-invalid');
                $('#tool-in-preisselect').show();
                nw = 1;
            }
            if (validatePayment()) {
                nw = 1;
            }
            if ($('#in-zahlart').val()=='2' || $('#in-zahlart').val()=='4') {
                if ($('#in-schein').val()=='0') {
                    $('#in-schein').addClass('is-invalid');
                    $('#tool-in-schein').show();
                    nw = 1;
                }
                if ($('#in-changecoin').val()=='') {
                    $('#in-changecoin').addClass('is-invalid');
                    $('#tool-in-changecoin').show();
                    nw = 1;
                }
            }

            if ($('#in-zahlart').val()=='3' || $('#in-zahlart').val()=='4') {
                if ($('#in-coin').val()=='') {
                    $('#in-coin').addClass('is-invalid');
                    $('#tool-in-coin').show();
                    nw = 1;
                }
                if ($('#in-changecoin').val()=='') {
                    $('#in-changecoin').addClass('is-invalid');
                    $('#tool-in-changecoin').show();
                    nw = 1;
                }
            }

            if (changeClaimExceedsPaid()) {
                $('#in-schein, #in-coin, #in-changecoin, #in-preisselect').addClass('is-invalid');
                $('#tool-in-sum').show();
                nw = 1;
            }

            if (nw==1) {a.preventDefault()}

        }

        if ($('#in-grund').val()=='4') {

            nw = 0;

            if ($('#in-sorteselect').val()=='') {
                $('#in-sorteselect').addClass('is-invalid');
                $('#tool-in-sorteselect').show();
                nw = 1;
            }
            if ($('#in-preisselect').val()=='') {
                $('#in-preisselect').addClass('is-invalid');
                $('#tool-in-preisselect').show();
                nw = 1;
            }
            if ($('#in-sorteget').val()=='') {
                $('#in-sorteget').addClass('is-invalid');
                $('#tool-in-sorteget').show();
                nw = 1;
            }

            if (nw==1) {a.preventDefault()}

        }

        if ($('#in-grund').val()=='5') {

            nw = 0;

            if ($('#in-sorteselect').val()=='') {
                $('#in-sorteselect').addClass('is-invalid');
                $('#tool-in-sorteselect').show();
                nw = 1;
            }
            if ($('#in-preisselect').val()=='') {
                $('#in-preisselect').addClass('is-invalid');
                $('#tool-in-preisselect').show();
                nw = 1;
            }
            if ($('#in-sorteget').val()=='') {
                $('#in-sorteget').addClass('is-invalid');
                $('#tool-in-sorteget').show();
                nw = 1;
            }
            if ($('#in-preisget').val()=='') {
                $('#in-preisget').addClass('is-invalid');
                $('#tool-in-preisget').show();
                nw = 1;
            }

            if (nw==1) {a.preventDefault()}

        }

        if ($('#in-grund').val()=='6') {

            nw = 0;

            if ($('#in-sorteselect').val()=='') {
                $('#in-sorteselect').addClass('is-invalid');
                $('#tool-in-sorteselect').show();
                nw = 1;
            }
            if ($('#in-preisselect').val()=='') {
                $('#in-preisselect').addClass('is-invalid');
                $('#tool-in-preisselect').show();
                nw = 1;
            }
            if ($('#in-preisget').val()=='') {
                $('#in-preisget').addClass('is-invalid');
                $('#tool-in-preisget').show();
                nw = 1;
            }

            if (nw==1) {a.preventDefault()}

        }

        validateBrandFields(a);
        validateWhenBlock(a);

    }

    if (indi=='3') {

        if ($('#in-anrede').val()=='0') {
            $('#in-anrede').addClass('is-invalid');
            $('#tool-in-anrede').show();
            nw = 1;
        }

        if ($('#in-name').val()=='') {
            $('#in-name').addClass('is-invalid');
            $('#tool-in-name').show();
            nw = 1;
        }
        if ($('#in-mail').val()=='' && $('#in-phone').val()=='') {
            $('#in-mail').addClass('is-invalid');
            $('#in-phone').addClass('is-invalid');
            $('#tool-in-kontaktmail').show();
            $('#tool-in-kontaktphone').show();
            nw = 1;
        }
        if ($('#in-mail').val()!='') {
            var regex = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
            if(!regex.test($('#in-mail').val())) {
                $('#in-mail').addClass('is-invalid');
                $('#tool-in-nomail').show();
                nw = 1;
            } else {
                $('#tool-in-nomail').hide();
            }
        }
        if (($('#in-iban').val().length > 0 || $('#in-iban-dismiss-validation').val() == "1") && $('#in-bic').val().length < 1) {
            $('#in-bic').addClass('is-invalid');
            $('#tool-in-bic').addClass("show");
            $('#tool-in-bic').show();
            nw = 1;
        }
    }
    if (nw==1) {a.preventDefault()}
}






document.addEventListener('DOMContentLoaded', function () {
    // You can store the stepper instance in a global variable if you want to access it from inline onclick handlers

    if (document.getElementById('progressbar')) {
        window.stepper = new Stepper(
            document.querySelector('#progressbar'),
        {
                linear: true,
                animation: true,
            }
        );

        // Initial aktiv setzen
        setActiveStepper(1);

        document.getElementById('progressbar').addEventListener('show.bs-stepper', function (event) {
            $('.is-invalid').removeClass('is-invalid');
            $('.invalid-tooltip').hide();
            checker(event.detail.indexStep, event);

            // Aktiven Step markieren
            setActiveStepper(event.detail.indexStep);
        })
    }
});

// Hilfsfunktion zum Setzen der "active"-Klasse
function setActiveStepper(activeIndex) {
    document.querySelectorAll('.bs-stepper-header .step').forEach((step ) => {
        const stepnumber = step.getAttribute('data-target').replace( '#issue-l-', '');
        const idx = parseInt(stepnumber, 10);
        if (idx === activeIndex) {
            step.classList.add('active');
        } else {
            step.classList.remove('active');
        }
    });
}

var grabRequestInProgress = false;
function grabATM(atnumber) {
    $("#atnotfound").removeClass("show");
    $("#atblock").removeClass("show");
    if ((atnumber.length == 4 || atnumber.length == 6) && !grabRequestInProgress) {
        var fullNumber = atnumber.length == 4 ? '33' + atnumber : atnumber;
        grabRequestInProgress = true;
        $.ajax({
            url: '/api/atm/A' + fullNumber,
            type: 'GET',
            dataType: 'json',
            success: function(data) {
                if (data.plz) {
                    $('#atfind').val(data.plz.replace(/^P+/g, '') + ' ' + data.town);
                    $('#atsearch').addClass("show");
                    document.querySelector("#issue-l-1 button[data-testid='next-button']").disabled = false;
                    $('#realAt').val("A" + fullNumber);
                } else {
                    $('#atnotfound').addClass("show");
                }
                grabRequestInProgress = false;
            },
            error: function(jqXHR) {
                if (jqXHR && jqXHR.status === 429) {
                    $('#atblock').addClass("show");
                } else {
                    $('#atnotfound').addClass("show");
                }
                grabRequestInProgress = false;
            }
        });
    }
}

function showWhenBlock() {
    const block = document.getElementById('tog-when');
    if (!block) return;
    block.style.display = 'block';
    block.classList.add('show');
}

function hideWhenBlock() {
    const block = document.getElementById('tog-when');
    if (!block) return;
    block.style.display = 'none';
    block.classList.remove('show');
}

function showDateTimeInputs() {
    ['tog-in-date', 'tog-in-time'].forEach(function(id) {
        const elem = document.getElementById(id);
        if (!elem) return;
        elem.style.display = 'block';
        elem.classList.add('show');
    });
}

function applyDefaultDateTimeMode() {
    showWhenBlock();
    $('#ec-bank-warning').hide();
    updateFaultDateAgeHint();
    if ($('#in-date').val() !== '' && $('#in-time').val() !== '') {
        $('#tog-in-wann-button').hide();
        showDateTimeInputs();
    } else {
        $('#tog-in-wann-button').show();
    }
    var dateLabel = document.getElementById('in-date-label');
    var timeLabel = document.getElementById('in-time-label');
    if (dateLabel) dateLabel.textContent = dateLabel.dataset.default;
    if (timeLabel) timeLabel.textContent = timeLabel.dataset.default;
}

function applyEcDateTimeMode() {
    showWhenBlock();
    $('#ec-bank-warning').hide();
    $('#tog-in-wann-button').hide();
    var dateLabel = document.getElementById('in-date-label');
    var timeLabel = document.getElementById('in-time-label');
    if (dateLabel) dateLabel.textContent = dateLabel.dataset.ec;
    if (timeLabel) timeLabel.textContent = timeLabel.dataset.ec;
    $('#in-date').val('');
    $('#in-time').val('');
    showDateTimeInputs();
    updateFaultDateAgeHint();
}

function openEcVerwendungszweckModal() {
    var el = document.getElementById('ecVerwendungszweckModal');
    if (!el) return;
    bootstrap.Modal.getOrCreateInstance(el).show();
}


function getXsrfToken() {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; XSRF-TOKEN=`);
    if (parts.length === 2) return decodeURIComponent(parts.pop().split(';').shift());
}

function submitFault() {

    //get all values of select, inputs and textara and save it to a json object

    var requestData = {}

    document.querySelectorAll("input, select, textarea").forEach(function(input) {
        var index;
        if (input.localName === "select") {
            index = input.name === '' ? input.id : input.name;
            //get the value of the selected index
            if (index && input.selectedIndex > -1) {
                requestData[index] = input.options[input.selectedIndex].value;
            }

            return;
        }
        if (input.localName === "input") {
            index = input.name === '' ? input.id : input.name;
            if (index && index !== '_token') {
                requestData[index] = input.value;
            }
            return;
        }
        if (input.localName === "textarea") {
            index = input.name === '' ? input.id : input.name;
            if (index) {
                requestData[index] = input.value;
            }
            return;
        }
    })

    $('#send-success').removeClass("show");
    $('#send-success').hide();

    $('#send-error').removeClass("show");
    $('#send-error').hide();

    $.ajax({
        type: 'GET',
        url: "/sanctum/csrf-cookie",
        success: function(cookieData) {
            const token = getXsrfToken();
            $.ajax({
                url: '/api/atm/fault',
                type: 'POST',
                headers: {
                    'X-XSRF-TOKEN': token,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                dataType: 'json',
                contentType: 'application/json',
                data: JSON.stringify(requestData),
                success: function(data) {
                    if (data.vgnr) {
                        $('#vgout').html("<h5>" + data.vgnr + "</h5>");
                    }
                    $('#send-success').addClass("show");
                    $('#send-success').show();
                },
                error: function(data) {
                    $('#send-error').addClass("show");
                    $('#send-error').show();
                    var result = JSON.parse(data.responseText);
                    if (result.errors) {
                        var errorMsg ='<ul class="validation-errors alert alert-danger">';
                        for (var key in result.errors) {
                            if (result.errors.hasOwnProperty(key)) {
                                errorMsg += "<li>" + result.errors[key].join(', ') + '</li>';
                            }
                        }
                        errorMsg += '</ul>';
                        $('#submit-error-msg').html(errorMsg);
                    }
                }
            })
        }
    })
    //store csrf token from cookie in in data object
}
var ibanValidationMode = false;

function enableIBANValidation() {
    $('#ibanmsg').hide();
    $('#issue-l-3 #next-btn').prop('disabled', true);
    $('#issue-l-3 #next-btn').hide();
    $('#issue-l-3 #iban-validation-btn').show();
    $('#issue-l-3 #iban-validation-btn').prop('disabled', false);
    ibanValidationMode = true;
}

function disableIBANValidation() {
    $('#ibanmsg').hide();
    $('#issue-l-3 #next-btn').prop('disabled', false);
    $('#issue-l-3 #iban-validation-btn').prop('disabled', true);
    $('#issue-l-3 #iban-validation-btn').hide();
    $('#issue-l-3 #next-btn').show()
    ibanValidationMode = false;
}
$(document).ready(function() {
    // Convert IBAN and BIC inputs to uppercase
    $('#in-iban, #in-bic').on('input', function() {
        $(this).val($(this).val().toUpperCase());
        if ($(this).attr('id') === 'in-iban') {
            updateIbanLengthHint($(this).val());
        }
    });
    $('#iban-validation-ignore').click(function (ev) {
        ev.preventDefault();
        $('#in-iban-dismiss-validation').val(1);
        $('#ibanfailed').removeClass("show");
        $('#ibanfailed').hide();

        disableIBANValidation();
    });
    $('.back-to-form').click(function (ev) {
        ev.preventDefault();
        $("#send-error").hide();

        $('#senddata').addClass('btn-light');
        $('#senddata').removeClass('btn-primary');
        $("#senddata").prop('disabled', true);
        $("#confirm-detail").show();

        stepper.previous();
    });
    $('#statusform #in-iban').on('change', function() {
        enableIBANValidation();
    });

    $('#iban-validation-btn').click( function(event) {
        event.preventDefault();
        if ($('#in-iban').val()!='') {
            var cc = $('#in-iban').val().substring(0,2).toUpperCase();
            var expectedLen = ibanLengths[cc] || 22;
            if (($('#in-iban').val().length) < expectedLen){
                $('#in-iban').addClass('is-invalid');
                $('#in-iban').focus();
            } else {
                var timerInterval;
                Swal.fire({
                    title: 'IBAN check!',
                    html: '',
                    timer: 2000,
                    showConfirmButton: false,
                    didOpen: function () {
                        Swal.showLoading()
                        timerInterval = setInterval(function() {

                        }, 1000 * 4)
                        checkiban($('#in-iban').val());
                    },
                    willClose: function () {
                        clearInterval(timerInterval)
                    }
                }).then(function (result) {
                    if (
                        result.dismiss === Swal.DismissReason.timer
                    ) {
                        console.log('I was closed by the timer')
                    }
                })
            }
        }
    });


    $( "#preloader" ).hide()
    $('.skip-at-number-enter').click(function() {
        $('#atnumfield div').hide();
        $('#atnotfound').removeClass("show");
        $('#atinvalid').addClass("show");
        $('#atinvalid').show();
        $('#msgfalse').show();
    });

    $('#atnumber').focus(function() {
        $('#atnotfound').removeClass("show");
    });

    $('#atnumber').change(function() {
        var atnumber = $(this).val();
        grabATM(atnumber);
    });

    var atmDebounceTimer = null;
    $('#atnumber').keyup(function() {
        var atnumber = $(this).val();
        if (atmDebounceTimer) {
            clearTimeout(atmDebounceTimer);
            atmDebounceTimer = null;
        }
        if (atnumber.length < 4) {
            $('#tool-atnumber').show();
        } else if (atnumber.length == 6) {
            $('#tool-atnumber').hide();
            grabATM(atnumber);
        } else if (atnumber.length == 4) {
            $('#tool-atnumber').hide();
            atmDebounceTimer = setTimeout(function() {
                grabATM(atnumber);
            }, 800);
        }
    });


    $('#confirm').on('click', function() {
        $('#senddata').removeClass('btn-light');
        $('#senddata').addClass('btn-primary');
        $("#senddata").prop('disabled', false);
    });

    $("#ibanmsg").hover(function() {
        $(this).css('cursor','pointer');
    }, function() {
        $(this).css('cursor','auto');
    });

    $('#senddata').on('click', function(e) {
        e.preventDefault();
        $('#confirm-detail').hide();
        $('#nextbl1').hide();
        $('#confirm-send').show();
        $("#senddata").prop('disabled', true);
        submitFault();
    });

    $('#in-date').on('change', function() {
        $('#in-date').removeClass('is-invalid');
        $('#tool-in-date').hide();
        $('#tool-in-date-future').hide();
        updateFaultDateAgeHint();
        // Moving to an earlier day can clear a time that was flagged as future.
        $('#in-time').removeClass('is-invalid');
        $('#tool-in-time-future').hide();
        if ($('#in-date').val() != '' && $('#in-time').val() != '') {
            $('#tog-when').removeClass('border border-2 border-danger');
        }
    });

    $('#in-time').on('change', function() {
        $('#in-time').removeClass('is-invalid');
        $('#tool-in-time').hide();
        $('#tool-in-time-future').hide();
        if ($('#in-date').val() != '' && $('#in-time').val() != '') {
            $('#tog-when').removeClass('border border-2 border-danger');
        }
    });

    function clearWhenValidation() {
        $('#in-date, #in-time').removeClass('is-invalid');
        $('#tool-in-date, #tool-in-date-future, #tool-in-time, #tool-in-time-future').hide();
        $('#tog-when').removeClass('border border-2 border-danger');
    }

    $('#setjetzt').on('click', function() {
        var now = new Date();
        var pad = function(n) { return n < 10 ? '0' + n : '' + n; };
        $('#in-date').val(now.getFullYear() + '-' + pad(now.getMonth() + 1) + '-' + pad(now.getDate()));
        $('#in-time').val(pad(now.getHours()) + ':' + pad(now.getMinutes()));
        showDateTimeInputs();
        $('#tog-in-wann-button').hide();
        clearWhenValidation();
        updateFaultDateAgeHint();
    });

    $('#setspaeter').on('click', function() {
        $('#in-date').val('');
        $('#in-time').val('');
        showDateTimeInputs();
        clearWhenValidation();
        updateFaultDateAgeHint();
    });

    $('#in-sorteselect').on('input', function() {
        $('#in-sorteselect').removeClass('is-invalid');
        $('#tool-in-sorteselect').hide();
        $('#tool-in-sorteselect-unknown').hide();
    });

    $('#in-sorteget').on('input', function() {
        $('#in-sorteget').removeClass('is-invalid');
        $('#tool-in-sorteget').hide();
        $('#tool-in-sorteget-unknown').hide();
    });

    $('#in-coin').on('keypress', function() {
        $('#in-coin').removeClass('is-invalid');
        $('#tool-in-coin').hide();
        $('#tool-in-sum').hide();
        return (event.charCode >= 46 && event.charCode <= 57) || event.charCode == 44;
    });

    $('#in-changecoin').on('keypress', function() {
        $('#in-changecoin').removeClass('is-invalid');
        $('#tool-in-changecoin').hide();
        $('#tool-in-sum').hide();
        return (event.charCode >= 46 && event.charCode <= 57) || event.charCode == 44;
    });

    $('#in-preisselect').on('input', function() {
        $('#in-preisselect').removeClass('is-invalid');
        $('#tool-in-preisselect').hide();
        $('#tool-in-sum').hide();
    });

    $('#in-preisget').on('input', function() {
        $('#in-preisget').removeClass('is-invalid');
        $('#tool-in-preisget').hide();
    });

    $('#in-schein').on('change', function() {
        $('#in-schein').removeClass('is-invalid');
        $('#tool-in-schein').hide();
        $('#tool-in-sum').hide();
    });

    $('#in-zahlart').on('change', function() {
        $('#in-zahlart').removeClass('is-invalid');
        $('#tool-in-zahlart').hide();
    });

    $('#in-stoerart').on('change', function() {
        $('#in-stoerart').removeClass('is-invalid');
        $('#tool-in-stoerart').hide();
    });

    $('#in-iban').on('keyup', function() {
        if ($(this).attr('readonly') !== 'readonly') {
            $('#in-iban-validation-state').val("0");
            $('#in-bic').val('');
            if ($(this).val().length > 8) {
                enableIBANValidation();
            }
            updateIbanLengthHint($(this).val());
        }
    });

    $('#in-iban').on('change', function() {
        $(this).val($(this).val().replace(/\s/g, '')); // remove all whitespaces
        if ($('#in-iban-validation-state').val() == "0") {
            enableIBANValidation();
        }
    });

    $('#in-iban').on('keypress', function() {
        $('#ibanmsg').hide();
        $('#in-iban').removeClass('is-invalid');
        if (($('#in-iban').val().length) < 2) {
            return (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122);
        } else {
            return (event.charCode >= 47 && event.charCode <= 57)
        }
    });

    $('#in-display').on('keypress', function() {
      return (event.charCode >= 32 && event.charCode <= 33) || (event.charCode >= 40 && event.charCode <= 58) || (event.charCode >= 63 && event.charCode <= 122) || (event.charCode >= 128 && event.charCode <= 254);
    });

    $('#in-name').on('keypress', function() {

        return (event.charCode >= 32 && event.charCode <= 33) || (event.charCode >= 40 && event.charCode <= 58) || (event.charCode >= 63 && event.charCode <= 122) || (event.charCode >= 128 && event.charCode <= 254);

    });

    $('#in-msg').on('keypress', function() {

        return (event.charCode >= 32 && event.charCode <= 33) || (event.charCode >= 40 && event.charCode <= 58) || (event.charCode >= 63 && event.charCode <= 122) || (event.charCode >= 128 && event.charCode <= 254);

    });


    $('#in-kontoname').on('keypress', function() {

        return (event.charCode >= 32 && event.charCode <= 33) || (event.charCode >= 40 && event.charCode <= 58) || (event.charCode >= 63 && event.charCode <= 122) || (event.charCode >= 128 && event.charCode <= 254);

    });

    $('#in-phone').on('change', function() {

        return (event.charCode >= 47 && event.charCode <= 57) || event.charCode == 43 || event.charCode == 45;

        $('#in-phone').removeClass('is-invalid');
        $('#in-mail').removeClass('is-invalid');
        $('#tool-in-kontaktphone').hide();
        $('#tool-in-kontaktmail').hide();
    });

    $('#in-phone').on('keypress', function() {

        return (event.charCode >= 47 && event.charCode <= 57) || event.charCode == 43 || event.charCode == 45;

    });

    $('#in-mail').on('keypress', function() {
        $('#in-phone').removeClass('is-invalid');
        $('#in-mail').removeClass('is-invalid');
        $('#tool-in-kontaktphone').hide();
        $('#tool-in-kontaktmail').hide();
    });


    $('#in-phone').on('blur', function() {
        var item = $('#in-phone').val().replace(/[\/ \-]/g, '');

        if (item.substring(0, 2) == '00') {
            item = item.replace('00', '+');
        }
        if (item.substring(0, 1) == '0') {
            item = item.replace('0', '+49');
        }

        $('#in-phone').val(item);
    });

    $('#in-anrede').on('change', function() {
        $('#in-anrede').removeClass('is-invalid');
        $('#tool-in-anrede').hide();
    });

    $('#in-name').on('keypress', function() {
        $('#in-name').removeClass('is-invalid');
        $('#tool-in-name').hide();
    });

    $('#atnumber').on('keypress', function() {

        return event.charCode >= 48 && event.charCode <= 57

    });

    function showInput(elem) {
        elem.addClass("show");
        elem.show();
    }

    $('#in-grund').on('change', function() {
        $('.is-invalid').removeClass('is-invalid');
        $('.invalid-tooltip').hide();
        $('#in-stoerart').val('0');
        $('#in-display').val('');
        $('#in-sorteselect').val('');
        $('#in-preisselect').val('');
        $('#in-sorteget').val('');
        $('#in-preisget').val('');
        $('#in-zahlart').val('0');
        $('#in-schein').val('0');
        $('#in-coin').val('');
        $('#in-changecoin').val('');
        $('#in-iban').val('');
        $('#in-kontoname').val('');
        $('#in-anz-versuche').val('1');

        $('#tog_stoerart').hide();
        $('#tog_display').hide();
        $('#tog_sorteselect').hide();
        $('#tog_preisselect').hide();
        $('#tog_sorteget').hide();
        $('#tog_preisget').hide();
        $('#tog_zahlart').hide();
        $('#tog_schein').hide();
        $('#tog_coin').hide();
        $('#tog_changecoin').hide();
        $('#tog_kontoname').hide();
        $('#tog_iban').hide();
        $('#tog_bic').hide();
        $('#tog_anz_versuche').hide();

        var grundVal = $('#in-grund').val();
        if (grundVal == '0' || grundVal === '') {
            hideWhenBlock();
        } else if (grundVal == '2' || grundVal == '3') {
            // payment type still pending — wait for zahlart selection
            hideWhenBlock();
        } else {
            applyDefaultDateTimeMode();
        }

        if ($('#in-grund').val()=='1') {
            $('#tog_stoerart').show();
            showInput($('#tog_display'));
            showInput($('#tog_stoerart'));
        }

        if ($('#in-grund').val()>'1') {
            $('#tog_kontoname').show();
            $('#tog_iban').show();
            $('#tog_bic').show();
            showInput($('#tog_anz_versuche'));
        }
        if ($('#in-grund').val()=='2' || $('#in-grund').val()=='3') {
            // Display/Sorte/Preis and the date/time block stay hidden until
            // the customer picks a payment type — see the #in-zahlart handler.
            showInput($('#tog_zahlart'));
        }

        if ($('#in-grund').val()=='4') {
            $('#tog_display').addClass("show");
            showInput($('#tog_display'));
            showInput($('#tog_sorteselect'));
            showInput($('#tog_preisselect'));
            showInput($('#tog_sorteget'));
        }

        if ($('#in-grund').val()=='5') {
            $('#tog_display').addClass("show");
            showInput($('#tog_display'));
            showInput($('#tog_sorteselect'));
            showInput($('#tog_preisselect'));
            showInput($('#tog_sorteget'));
            showInput($('#tog_preisget'));
        }

        if ($('#in-grund').val()=='6') {
            $('#tog_display').addClass("show");
            showInput($('#tog_display'));
            showInput($('#tog_sorteselect'));
            showInput($('#tog_preisselect'));
            showInput($('#tog_preisget'));
        }
    });

    $('#in-zahlart').on('change', function() {
        // Changing payment type wipes any previous validation markers in step 2.
        $('#issue-l-2 .is-invalid').removeClass('is-invalid');
        $('#issue-l-2 .invalid-tooltip').hide();
        $('#tog-when').removeClass('border border-2 border-danger');
        $('#ec-bank-warning').removeClass('border border-2 border-danger');
        $('#ec-verwendungszweck-confirmed').val('');
        $('#tog_schein').hide();
        $('#tog_coin').hide();
        $('#tog_changecoin').hide();
        var zVal = $('#in-zahlart').val();
        var grundVal = $('#in-grund').val();
        // Reveal the question fields once the customer has picked a payment type.
        if (zVal && zVal != '0') {
            showInput($('#tog_display'));
            showInput($('#tog_sorteselect'));
            showInput($('#tog_preisselect'));
        } else {
            $('#tog_display').hide();
            $('#tog_sorteselect').hide();
            $('#tog_preisselect').hide();
        }
        if (zVal == '1') {
            $('#ec-bank-warning').hide();
            hideWhenBlock();
            openEcVerwendungszweckModal();
        } else if (zVal && zVal != '0') {
            $('#ec-bank-warning').hide();
            applyDefaultDateTimeMode();
        } else {
            $('#ec-bank-warning').hide();
            hideWhenBlock();
        }
        if (zVal == '2') {
            $('#tog_schein').show();
            $('#tog_schein').addClass("show");
        }
        if (zVal == '3') {
            $('#tog_coin').show();
            $('#tog_coin').addClass("show");
        }
        if (zVal == '4') {
            $('#tog_schein').show();
            $('#tog_schein').addClass("show");
            $('#tog_coin').show();
            $('#tog_coin').addClass("show");
        }
        // Reason 3 (Wechselgeld): also collect the missing-change amount for cash payments
        if (grundVal == '3' && (zVal == '2' || zVal == '3' || zVal == '4')) {
            showInput($('#tog_changecoin'));
        }
    });

    $(document).on('click', '[data-testid="ec-verwendungszweck-yes"]', function() {
        $('#ec-verwendungszweck-confirmed').val('1');
        $('#in-zahlart').removeClass('is-invalid');
        $('#tool-in-zahlart').hide();
        $('#ec-bank-warning').removeClass('border border-2 border-danger').hide();
        applyEcDateTimeMode();
    });

    $(document).on('click', '[data-testid="ec-verwendungszweck-no"]', function() {
        window.location.href = '/cancel';
    });

});
